







































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbSelect, mdbBtn } from '@folky-tools/mdbvue';
import { Characteristic } from '@/models/references-classification/characteristic';
import { CharacteristicValue } from '@/models/references-classification/characteristic-value';
import { required } from 'vuelidate/lib/validators';
import Swal from 'sweetalert2';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbSelect,
        mdbBtn
    },
    validations: {
        characteristic: { name: { required } }
    }
})
export default class EditCharacteristic extends Vue {
    @Prop(Characteristic) private characteristic!: Characteristic;
    private characteristicCopy: Characteristic = new Characteristic();
    private characteristicNameMaxCharLength: number = 32;
    private characteristicValueMaxCharLength: number = 32;

    private beforeMount(): void {
        this.characteristicCopy = this.characteristic.clone();
    }

    private hasErrors(): boolean {
        this.$v.characteristic.$touch();
        if (this.$v.characteristic.$error) {
            return true;
        }
        return false;
    }

    private addCharValue(): void {
        const charValue: any = new CharacteristicValue();
        this.characteristic.values.push(charValue);
    }

    private async removeCharValue(index: number, valueName: string): Promise<void> {
        if (valueName) {
            const questionResult = await Swal.fire({
                title: this.$i18n.t('components.businesses.editCharacteristic.actions.deleteValue.modal.title').toString(),
                html: '<h3>' + valueName + '</h3>' + this.$i18n.t('components.businesses.editCharacteristic.actions.deleteValue.modal.textHtml').toString(),
                type: 'warning',
                showCancelButton: true,
                reverseButtons: true,
                focusConfirm: false,
                focusCancel: true,
                confirmButtonText: this.$i18n.t('components.businesses.editCharacteristic.actions.deleteValue.modal.confirm.doConfirm').toString(),
                cancelButtonText: this.$i18n.t('components.businesses.editCharacteristic.actions.deleteValue.modal.doCancel').toString(),
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-danger'
                },
                animation: false
            });
            if (questionResult.value) {
                this.characteristic.values.splice(index, 1);
            }
        } else {
            this.characteristic.values.splice(index, 1);
        }
    }
}
